import { useMemo } from "react";
import { AuditTask } from "../../types";
import { PanelCard } from "../ui/panel";
import {
  buildAssociateTaskPerformance,
  hasClosedTasks,
} from "./auditTaskPerformanceUtils";
import TaskPerformanceCard from "./TaskPerformanceCard";

interface DbUser {
  id: number;
  username: string;
  role?: string;
  is_active?: boolean;
}

interface AssociateTaskPerformanceProps {
  tasks: AuditTask[];
  users: DbUser[];
}

export default function AssociateTaskPerformanceSection({
  tasks,
  users,
}: AssociateTaskPerformanceProps) {
  const rows = useMemo(
    () => buildAssociateTaskPerformance(tasks, users),
    [tasks, users]
  );
  const anyClosed = hasClosedTasks(tasks);

  if (tasks.length === 0) return null;

  return (
    <PanelCard
      title="Performance associati"
      subtitle="Riepilogo storico per membro del team"
    >
      {!anyClosed && rows.length > 0 && (
        <p className="mb-4 rounded-xl border border-dashed border-secondary/15 bg-secondary/[0.02] px-4 py-3 text-center text-sm text-secondary/50">
          Nessuna task chiusa ancora — le metriche mostrano solo le task attive.
        </p>
      )}

      {rows.length === 0 ? (
        <p className="rounded-xl border border-dashed border-secondary/15 py-12 text-center text-sm text-secondary/50">
          Nessun membro del team con task assegnate
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {rows.map((row) => (
            <TaskPerformanceCard key={row.userId} row={row} />
          ))}
        </div>
      )}
    </PanelCard>
  );
}
